<template>
  <div class="flex flex-1 flex-col">
    <section
      class="relative overflow-hidden border-b border-slate-200 bg-white"
      aria-labelledby="hero-heading"
    >
      <div
        class="pointer-events-none absolute inset-0 bg-[radial-gradient(60rem_30rem_at_85%_-10%,rgba(0,141,210,0.10),transparent_70%)]"
        aria-hidden="true"
      ></div>
      <div
        class="relative mx-auto grid max-w-7xl items-center gap-12 px-4 py-16 sm:px-6 sm:py-20 lg:grid-cols-[minmax(0,7fr)_minmax(0,5fr)] lg:px-8 lg:py-24"
      >
        <div>
          <p
            class="inline-flex items-center gap-2 rounded-full bg-brand-50 px-3 py-1 text-xs font-semibold text-brand-700 ring-1 ring-inset ring-brand-100"
          >
            <span class="h-1.5 w-1.5 rounded-full bg-brand"></span>
            Selli tn 3, Tartu
          </p>
          <h1
            id="hero-heading"
            class="mt-5 text-4xl font-extrabold tracking-tight text-ink sm:text-5xl"
          >
            Rehvid ja rehvitööd Tartus
          </h1>
          <p class="mt-5 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
            Teeme rehvitööd kiirelt ja täpselt. Meie meeskond nõustab, leiab
            sobiva lahenduse ja hoolitseb, et saaksid turvaliselt teele tagasi.
          </p>
          <div class="mt-8 flex flex-wrap gap-3">
            <router-link
              to="/rehvid"
              class="inline-flex items-center gap-2 rounded-lg bg-brand px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-brand-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
            >
              Otsi rehve
              <svg
                class="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                />
              </svg>
            </router-link>
            <router-link
              to="/contactus"
              class="inline-flex items-center rounded-lg border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-ink shadow-sm transition hover:border-slate-400 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
            >
              Võta ühendust
            </router-link>
          </div>
        </div>

        <div
          class="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8"
        >
          <h2 class="text-sm font-semibold uppercase tracking-wider text-slate-500">
            Miks SaurusRehv?
          </h2>
          <ul class="mt-5 space-y-4">
            <li
              v-for="point in sellingPoints"
              :key="point"
              class="flex items-start gap-3 text-sm font-medium text-ink sm:text-base"
            >
              <span
                class="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-600"
              >
                <svg
                  class="h-3.5 w-3.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="3"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m4.5 12.75 6 6 9-13.5"
                  />
                </svg>
              </span>
              {{ point }}
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section
      class="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20"
      aria-labelledby="services-heading"
    >
      <div class="max-w-2xl">
        <h2
          id="services-heading"
          class="text-2xl font-bold tracking-tight text-ink sm:text-3xl"
        >
          Mis me pakume
        </h2>
        <p class="mt-3 text-base text-slate-600">
          Rehvilahendused sõiduautodest rasketehnikani – müük, paigaldus,
          remont ja taastamine.
        </p>
      </div>
      <div class="mt-10">
        <Pakkumine />
      </div>
    </section>
  </div>
</template>

<script>
import Pakkumine from "@/components/Pakkumine.vue";

export default {
  name: "HomeView",
  components: {
    Pakkumine,
  },
  data() {
    return {
      sellingPoints: [
        "Üle 30 aasta kogemust",
        "Sõiduauto-, veoauto-, traktori- ja tööstusrehvid",
        "Rehvitööd kohapeal Tartus",
        "Rehvide taastamine koostööpartnerite kaudu",
      ],
    };
  },
};
</script>
